/**
 * プラン一覧、利用中一覧の絞り込み表示機能を管理するStateを扱うモジュール
 */
import { ActionsUnion, createAction } from 'common/utils/action-utils';

export enum ActionTypes {
  SET_PLAN_VALUE = 'app/filter/SET_PLAN_VALUE',
  SET_MODEL_VALUE = 'app/filter/SET_MODEL_VALUE',
  SET_MODEL_OPTIONS = 'app/filter/SET_MODEL_OPTIONS'
}

/**
 * プランのプルダウンの値を更新するActionを作成する
 * @param {PlanOptionValue} payload 選択されたプルダウンの値
 */
export const setPlanValue = (payload: PlanOptionValue) =>
  createAction(ActionTypes.SET_PLAN_VALUE, payload);

/**
 * 機種のプルダウンの値を更新するActionを作成する
 * @param {string} payload 選択されたプルダウンの値
 */
export const setModelValue = (payload: string) =>
  createAction(ActionTypes.SET_MODEL_VALUE, payload);

/**
 * 機種のプルダウンの選択肢を更新するActionを作成する
 */
export const setModelOptions = (payload: string[]) =>
  createAction(ActionTypes.SET_MODEL_OPTIONS, payload);

const actions = {
  setPlanValue,
  setModelValue,
  setModelOptions
};

type FilterAction = ActionsUnion<typeof actions>;

export enum PlanOptionValue {
  /**すべてのプラン */
  ALL_PLAN = '',
  /** カメラ有償機能
   * カメラ有償機能を選択された時にクエリやmodelValueが'all'を指定する必要があるためここでの値を'all'とする
   */
  CAMERA_PAID_FEATURES = 'all',
  /** アプリ/サービス(カメラ有償機能以外) */
  APP_SERVICE = 'app'
}

export interface FilterState {
  /** プランのプルダウンの値 */
  planValue: PlanOptionValue;
  /** 機種のプルダウンの値
   * 空文字(-)、all(すべての機種)、機種名
   */
  modelValue: string;
  /** 機種のプルダウンの選択肢
   * 「すべてのプラン」が選択されている時の表示は「-」
   * 「カメラ有償機能」を選択した時の初期表示は'all'で「すべての機種」
   */
  modelOptions: string[];
}

const initialState: FilterState = {
  planValue: PlanOptionValue.ALL_PLAN,
  modelValue: '',
  modelOptions: []
};

export default (
  state: FilterState = initialState,
  action: FilterAction
): FilterState => {
  switch (action.type) {
    case ActionTypes.SET_PLAN_VALUE:
      return { ...state, planValue: action.payload };
    case ActionTypes.SET_MODEL_VALUE:
      return { ...state, modelValue: action.payload };
    case ActionTypes.SET_MODEL_OPTIONS:
      return { ...state, modelOptions: action.payload };
    default:
      return state;
  }
};
